import {AuthState} from "../_auth/types";
import {API_BASE_URI} from "../_api/index";

// Redirect URI: will need to point to current URI location
// redirect_uri: `https://localhost:{3000 or 20080}}/oauth`,
export const AUTH_CONFIG = {
  domain: "auth.qa.data-axle.com",
  client_id: "60ff86461981e722e264349f",
  redirect_uri: `${API_BASE_URI}/oauth`,
  audience: "https://core-services.data-axle.com/api",
  // Bad Idea to store this here
  client_secret: "b594c65f6a9da7bea3c55c84",
};

// export const signup_info_uri: string = "https%3A%2F%2Fplatform.data-axle.com%2Fsignup_information";
// export const signup_uri: string = `//${AUTH_CONFIG.domain}/signups/new?client_id=${AUTH_CONFIG.client_id}&information_uri=${signup_info_uri}`;
// export const  forgot_password_uri: string = `//${AUTH_CONFIG.domain}/password_resets/new`;

/**
 * The initial auth state.
 */
export const initialAuthState: AuthState = {
  isAuthenticated: false,
  canNavigateState: true,
  isLoading: true,
};